import { render, staticRenderFns } from "./ShortcutsInfoModal.vue?vue&type=template&id=686fe6c0&scoped=true&"
import script from "./ShortcutsInfoModal.vue?vue&type=script&lang=js&"
export * from "./ShortcutsInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutsInfoModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ShortcutsInfoModal.vue?vue&type=style&index=1&id=686fe6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686fe6c0",
  null
  
)

export default component.exports